import * as PropTypes from 'prop-types';
import React from 'react';

export interface Cell {
  key: string;
  contentsClassName?: string;
  cellClassName?: string;
  contents: React.ReactNode;
}

export const CELL_SHAPE = PropTypes.shape({
  key: PropTypes.string.isRequired,
  contentsClassName: PropTypes.string,
  cellClassName: PropTypes.string,
  contents: PropTypes.node,
});

export interface Row {
  id: string;
  cells: Array<Cell>;
  rowClassName?: string;
  /**
   * Elements to be placed at right end of the row.
   */
  actionGroup?: React.ReactNode | null;
}

export const ROW_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(CELL_SHAPE.isRequired).isRequired,
  rowClassName: PropTypes.string,
});
